export const PAYMENTS_SEARCH_RESULT_TEST_ID = 'payments-search-result';
